import React from 'react';
import UserClientTable from 'components/UserClientTable';

const Client: React.FC = () => <UserClientTable />;

export default Client;
